import classNames from "classnames";
import { IOrganizationBankInfo } from "../../../../../../setup/api/services/organization/models";
import styles from "./styles.module.scss";

interface IBankCardProps {
  bankInfo: IOrganizationBankInfo;
}

const BankCard = ({ bankInfo }: IBankCardProps) => {
  return (
    <div className={classNames(styles.bank_wrapper)}>
      <div className={styles.ml2}>
        <div className={styles["bank_icon_wrapper"]}>
          <img
            src="/assets/images/svg/bank.svg"
            className={styles["dropdown_icon"]}
          />
        </div>
      </div>
      <div className={styles["bank_info"]}>
        <div className={styles["bank_details"]}>
          <p dir="ltr" className={styles["iban"]}>
            {bankInfo.iban.slice(0, -4).replace(/./g, "*")}
            {bankInfo.iban.slice(-4)}
          </p>
          <p className={styles["bank_name"]}>{bankInfo.bank?.arabicName}</p>
        </div>
      </div>
    </div>
  );
};

export default BankCard;
